// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://alqonwhniaypjwdouyon.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFscW9ud2huaWF5cGp3ZG91eW9uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg0ODUxNTIsImV4cCI6MjA2NDA2MTE1Mn0.USMwThpPQBlHX8DlhaOUURW495bBOKJpk69KYeq99Ss";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);